import { UrlObject } from 'url';

import { useRouter } from 'next/navigation';

import { BASE_PATH } from '@/constants/base-path';

export function useAppRouter() {
  const router = useRouter();

  const push = (url: string, options?: {}) => router.push(withBasePath(url) as string, options);
  const replace = (url: string, options?: {}) => router.replace(withBasePath(url) as string, options);

  return { ...router, push, replace };
}

export function addBasePath(href: string): string {
  if (href.startsWith('http') || href.includes(BASE_PATH)) {
    return href;
  }

  return `${BASE_PATH}${href}`;
}

export const withBasePath = (href: string | UrlObject): string | UrlObject => {
  if (typeof href === 'object') {
    const { pathname, href: hrefPath } = href;

    return {
      ...href,
      href: hrefPath ? (addBasePath(hrefPath as string) as string) : undefined,
      pathname: pathname ? (addBasePath(pathname as string) as string) : undefined,
    };
  }

  return addBasePath(href);
};
